export type GlobalHeaderMode = "logo" | "title" | "loan-context";

export type LoanCentricHeaderPage =
  | "home"
  | "my-loans"
  | "settings"
  | "dashboard"
  | "application";

export interface LoanCentricGlobalHeaderChrome {
  readonly headerMode: GlobalHeaderMode;
  readonly title?: string;
}

/**
 * Resolves GlobalHeader logo vs title vs loan-context chrome for loan-centric IA.
 * Title / loan-context modes are for mobile/tablet; desktop shells ignore them in GlobalHeader.
 * Settings uses dedicated /settings route (not profile overlay).
 * Dashboard phone: loan-context (back + address → /my-loans). Application keeps logo (US-24).
 */
export function getLoanCentricGlobalHeaderChrome(options: {
  readonly enabled: boolean;
  readonly page: LoanCentricHeaderPage;
}): LoanCentricGlobalHeaderChrome | undefined {
  if (!options.enabled) {
    return undefined;
  }

  if (options.page === "settings") {
    return { headerMode: "title", title: "Settings" };
  }

  if (options.page === "my-loans") {
    return { headerMode: "title", title: "Loans" };
  }

  if (options.page === "dashboard") {
    return { headerMode: "loan-context" };
  }

  return { headerMode: "logo" };
}
